<template>
  <v-card
    class="pa-0 ma-0 justify-center preview-container"
    flat
  >
    <v-card-title :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-2': !$vuetify.breakpoint.smAndDown, 'pb-2': fromSummary}" v-show="editedBusinessDetails">
      <v-card
        class="pa-0 ma-0"
        flat
      >
        <v-container class="pa-0 ma-0">
          <v-layout justify-center row wrap>
            <v-flex
              xs12
              :class="{'separator': fromSummary }"
            >
              <edit-creative
                :for-summary="fromSummary"
                :show-creative="creativesPreviewMode || !$vuetify.breakpoint.xsOnly"
                :show-edit-fields="!creativesPreviewMode"
                :edited-business-details="editedBusinessDetails"
                @isBtnDisabled="updateIsBtnDisabled"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-card-title>
    <v-card-actions class="py-0 pb-2 card-actions">
      <v-flex xs12 :class="{'ml-3':!$vuetify.breakpoint.xsOnly}">
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex :class="{ 'shrink mr-2': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              color="primary"
              @click="saveCreativeChanges"
              :disabled="isBtnDisabled"
              :loading="isUpdating"
            >
              <span class="text-capitalize" v-if="showCreativesPreviewButton">{{ $t('message.preview') }} </span>
              <span class="text-capitalize" v-else> {{ $t('message.done') }}</span>
            </v-btn>
          </v-flex>
          <v-flex :class="{ 'shrink ml-2': !$vuetify.breakpoint.xsOnly, 'xs12 mb-2': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              color="primary"
              outline
              v-if="!$vuetify.breakpoint.xsOnly"
              @click="discardChanges"
            >
              {{ $t('message.bizgainOnboarding.discard') }}
            </v-btn>
            <span
              class="text-xs-center font-bold"
              @click="discardChanges"
              v-else
            >
              <a
                class="text-xs-center my-1"
              > {{ $t('message.bizgainOnboarding.discard') }}</a>
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  VCard,
  VCardTitle,
  VCardActions,
  VContainer,
  VLayout,
  VFlex
} from 'vuetify/lib';
import EditCreative from 'Features/bizgainOnboarding/pages/imageCreativesCreativeEdit/components/Edit';
export default {
  components: {
    VCard,
    VCardTitle,
    VCardActions,
    VContainer,
    VLayout,
    VFlex,
    EditCreative
  },
  props: {
    editedBusinessDetails: {
      type: Object,
      default: null
    },
    extractedCreativeDetails: {
      type: Object,
      default: null
    },
    facebookAdDetails: {
      type: Object,
      default: null
    },
    template: {
      type: Object,
      default: null
    },
    fromSummary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isBtnDisabled: false,
      creativesPreviewMode: false,
      initialEditedBusinessDetails: null,
      isUpdating: false
    }
  },
  computed: {
    showCreativesPreviewButton(){
      return this.$vuetify.breakpoint.smAndDown && !this.creativesPreviewMode;
    }
  },
  created(){
    this.initialEditedBusinessDetails = JSON.parse(JSON.stringify(this.editedBusinessDetails))
  },
  methods: {
    updateIsBtnDisabled(isBtnDisabled){
      this.isBtnDisabled = isBtnDisabled;
      this.$emit('isBtnDisabled', isBtnDisabled);
    },
    discardChanges(){
      this.$emit('close-dialog');
      this.$emit('creative-discarded', JSON.parse(JSON.stringify(this.initialEditedBusinessDetails)));
    },
    showCreativePreview(){
      this.creativesPreviewMode = true;
    },
    saveCreativeChanges(){
      if(this.$vuetify.breakpoint.smAndDown && !this.creativesPreviewMode){
        this.showCreativePreview();
      }
      else if(this.fromSummary){
        this.isUpdating = true;
        this.$emit('updateBusinesssandCreativeDetails');
      }else{
        this.$emit('close-dialog');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .preview-container{
    align-items: center;
    display: grid;
  }

  .font-bold{
    font-weight: 500;
  }
  .separator{
    border-bottom: 1px solid #aaaaaa;
  }
</style>